import {
  Bubble,
  Heading,
  LinkWithButtonStyles,
  Icon,
} from '@frontendmentorio/design-system-v2';

export default function LockedCard({ children, CTA, href }) {
  return (
    <div className="mt-5 tablet:mt-0" data-testid="locked-card">
      <div className="bg-gray-100 container-xl flex flex-col gap-5 items-center px-5 py-7 relative rounded-xl text-center w-full">
        <Bubble className="absolute-center-x bg-neutral-200 top-[-2rem]">
          <Icon className="text-xl" name="lock-keyhole" style="solid" />
        </Bubble>

        <Heading level="4" tagName="h2">
          This section is locked
        </Heading>

        <p>{children}</p>

        <LinkWithButtonStyles href={href}>{CTA}</LinkWithButtonStyles>
      </div>
    </div>
  );
}
